<template>
  <vs-table :data="data">
    <template slot="thead">
      <th-sort
        :text="$t('period')"
        column="bank_statements.year,bank_statements.month"
        @sort="handleClickSort"
      />
      <th-sort
        :text="$t('client')"
        column="cl.ClientName"
        @sort="handleClickSort"
      />
      <th-sort
        :text="$t('bank')"
        column="banks.short_name"
        @sort="handleClickSort"
      />
      <th-sort
        :text="$t('account')"
        column="baccount.number"
        @sort="handleClickSort"
      />
      <th-sort
        :text="$t('currency')"
        column="baccount.currency"
        @sort="handleClickSort"
      />
      <vs-th class="qb-sticky"> PDF </vs-th>
    </template>

    <template slot-scope="{ data }">
      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
        <vs-td class="text-left">
          {{ `${data[indextr].year}-${data[indextr].month}` }}
        </vs-td>
        <vs-td class="text-left">
          {{ data[indextr].client_name }}
        </vs-td>
        <vs-td class="text-left">
          {{ data[indextr].bank_short_name }}
        </vs-td>
        <vs-td class="text-left">
          {{ data[indextr].number_account }}
        </vs-td>
        <vs-td class="text-left">
          {{ data[indextr].currency }}
        </vs-td>
        <vs-td :data="data[indextr].id">
          <div>
            <action-pdf-viewer :files="stringToJson(data[indextr].url_files)" />
            <action-icon
              icon="EditIcon"
              :tooltip="$t('edit')"
              @click="editData(data[indextr])"
              v-if="hasPermission(['IU BANK STATEMENT EDIT'])"
            />
            <action-delete
              @delete="deleteStatment(data[indextr].id)"
              v-if="hasPermission(['IU BANK STATEMENT EDIT'])"
            />
          </div>
        </vs-td>
      </vs-tr>
      <vs-tr>
        <vs-td colspan="100%">
          <div v-if="data.length" v-observe-visibility="infiniteHandler"></div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
</template>

<script>
import ActionPdfViewer from '@/views/components/actions/ActionPdfViewer.vue'
import ActionDelete from '@/views/components/actions/ActionDelete.vue'
import ActionIcon from '@/views/qb-components/actions/ActionIcon.vue'
import loading from '@/mixins/Loading.js'
import validate from '@/mixins/Validate.js'
import ThSort from '@/views/components/ThSort.vue'

export default {
  components: {
    ActionPdfViewer,
    ActionDelete,
    ActionIcon,
    ThSort
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    deleteStatment(id) {
      this.$store
        .dispatch('statement/deleteStatement', { bank_statement_id: id })
        .then((res) => {
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Item Deleted',
          })
        })
        .catch((err) => {
          this.displayErrors(err)
        })
    },
    stringToJson(obj) {
      let arr = []
      if (obj !== '') {
        arr = JSON.parse(obj)
      }
      return arr
    },
    infiniteHandler(isVisible) {
      if (!isVisible) {
        return
      }
      this.$emit('loadMore')
    },
    editData(data) {
      this.$emit('edit-side-bar', data)
    },
    handleClickSort(e) {
      this.$emit('sort', e)
    }
  },
  mixins: [loading, validate],
}
</script>

<style>
.qb-sticky {
  background: white;
  position: sticky;
  top: 0;
}
</style>
